module.exports = __webpack_public_path__ + "img/plusIcon.467d3b4e.svg";